import React from 'react';

import { Button, BUTTON_TYPES, Spacer } from '@badi/badi-components';

import { translate } from 'base/shared/Localization';
import FloatingChatBubble from 'components/FloatingChatBubble';
import BookingFooter from '../footer';

const MoveInOutStepFooter = ({
  stepIsValid,
  onSubmit = () => {},
  skipMessageStep,
  buttonVariant = BUTTON_TYPES.PRIMARY,
  isBadiPlusRoom = true,
  disabled = true,
  isLoading = false,
  room,
  moveIn,
  moveOut,
  currentUserEmail,
}) => {
  return (
    <BookingFooter showProtectedMark={false}>
      <FloatingChatBubble
        room={room}
        moveIn={moveIn}
        moveOut={moveOut}
        currentUserEmail={currentUserEmail}
      />
      <Button
        data-qa="submit-step"
        disabled={!stepIsValid || disabled}
        fullWidth={true}
        grow={1}
        onClick={onSubmit}
        variant={buttonVariant}
      >
        {isLoading
          ? translate('booking.new.sending_button')
          : translate('booking.new.continue_button')}
      </Button>
    </BookingFooter>
  );
};

export default MoveInOutStepFooter;
